import { boot } from 'quasar/wrappers';
import { useAccountStore } from 'src/stores/account';
import { ROUTES, SERVICES } from 'src/enums';
import { useAppStore } from 'stores/app';
import { useBlogStore } from 'stores/blog';
import { EventBus, Loading, LocalStorage } from 'quasar';
import { useProductStore } from 'stores/product';

export default boot(({
 app, store, router, ssrContext,
}) => {
  Loading.show();
  const bus = new EventBus();
  app.provide('bus', bus);

  const isServiceHost = ssrContext
    ? ssrContext.req.headers.host.includes(process.env.SERVICE_DOMAIN)
    : window.location.href.includes(process.env.SERVICE_DOMAIN);

  app.provide('isServiceHost', isServiceHost);

  const appStore = useAppStore();
  const accountStore = useAccountStore(store);
  const productStore = useProductStore(store);
  const blogStore = useBlogStore(store);
  const blogGuid = LocalStorage.getItem('blogGuid');

  // eslint-disable-next-line consistent-return
  router.beforeEach(async (to, from, next) => {
    appStore.layoutTitle = null;
    appStore.layoutIcon = null;

    if (isServiceHost && to.name === ROUTES.RENDER.BLOG) {
      return next({ name: ROUTES.DASHBOARD, params: { blogGuid } });
    }

    // TODO: added here excluded guest pages
    if (to.meta.auth && !accountStore.account) {
      try {
        await Promise.all([
          accountStore.getAccount(),
          productStore.getUpgradeLinks(),
        ]);
      } catch (error) {
        console.log(error);
        if (!to.meta.skipRedirect) {
          next({
            name: ROUTES.AUTH,
            query: { ...to.query, redirectUrl: to.fullPath },
            params: to.params,
          });
        }
      }
    }

    if (accountStore.isMyAccount && ![ROUTES.MY.BOOK, ROUTES.MY.PROFILE, ROUTES.MY.PURCHASE_HISTORY, ROUTES.BOOKS.PREVIEW].includes(to.name)) {
      return next({ name: ROUTES.MY.BOOK });
    }

    if (to.meta.blog) {
      if (!accountStore.account.availableServices?.funkiblog) {
        return next({ name: ROUTES.HOME });
      }

      appStore.service = SERVICES.BLOG;

      if (!blogStore.blog) {
        await blogStore.getBlogs();
      }
    }

    if (to.meta.social) {
      if (!accountStore.account.availableServices?.funkisocial) {
        return next({ name: ROUTES.HOME });
      }

      appStore.service = SERVICES.SOCIAL;
    }

    if (to.meta.reply) {
      if (!accountStore.account.availableServices?.funkireply) {
        return next({ name: ROUTES.HOME });
      }

      appStore.service = SERVICES.REPLY;
    }

    if (to.meta.tube) {
      if (!accountStore.account.availableServices?.funkitube) {
        return next({ name: ROUTES.HOME });
      }

      appStore.service = SERVICES.TUBE;
    }

    if (to.meta.profile && appStore.service !== SERVICES.PROFILE) {
      appStore.service = SERVICES.PROFILE;
      appStore.backRoute = from.fullPath;
    }

    next();
  });
});
